"use client";

import { Mail, MapPin, Phone } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactDetailsMap() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const mapRef = useRef<HTMLDivElement>(null);
  const [tilt, setTilt] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const mapEl = mapRef.current;
    if (!mapEl) return;
    const handleMouseMove = (e: MouseEvent) => {
      const rect = mapEl.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      const tiltX = (y - centerY) / centerY * 2;
      const tiltY = (x - centerX) / centerX * 2;
      setTilt({
        x: tiltX,
        y: tiltY
      });
    };
    const handleMouseLeave = () => {
      setTilt({
        x: 0,
        y: 0
      });
    };
    mapEl.addEventListener("mousemove", handleMouseMove);
    mapEl.addEventListener("mouseleave", handleMouseLeave);
    return () => {
      mapEl.removeEventListener("mousemove", handleMouseMove);
      mapEl.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);
  const contactItems = [{
    icon: MapPin,
    label: "Address",
    value: "Donvale VIC 3111"
  }, {
    icon: Phone,
    label: "Phone",
    value: "0432 061 310"
  }, {
    icon: Mail,
    label: "Email",
    value: "strucon.group@hotmail.com"
  }];
  return <section ref={sectionRef} className="bg-light-background py-16 px-4 sm:px-6 lg:px-8">
			<div className="mx-auto max-w-7xl">
				<div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
					{}
					<div className="lg:col-span-4">
						<div className="space-y-6">
							{contactItems.map((item, i) => {
              const Icon = item.icon;
              return <div key={i} data-index={i} className={`flex items-start gap-4 ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
                animationDelay: `${i * 150}ms`
              }}>
										<div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-light">
											<Icon className="h-6 w-6 text-primary-dark" strokeWidth={2} />
										</div>
										<div className="flex-1 pt-1">
											
											<p className="mt-1 text-base font-medium text-foreground-light">
												{item.value}
											</p>
										</div>
									</div>;
            })}
						</div>
					</div>

					{}
					<div className="lg:col-span-8">
						<div ref={mapRef} className={`relative h-80 overflow-hidden rounded-lg shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:scale-[1.02] lg:h-full ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
            animationDelay: "300ms",
            transform: `perspective(1000px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`
          }}>
							<div className="h-full w-full bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1518624/img/contact_location_map_view.png)]" role="img" aria-label="Location map" />
						</div>
					</div>
				</div>
			</div>
		</section>;
}